// ** Initialize State
const initialState = {
  externalImage: null,
  userData: [],
  alertPersons: [],
  userDataAnimation: [],
  avirStatus: true,
  ntfaceStatus: true
}

const NTFS_STORE = (state = initialState, action) => {
  switch (action.type) {
    case "SEARCH_USER_IMAGE":
      return { ...state, externalImage: action.data }
    case "SEARCH_USER":
      return { ...state, userData: action.data }
    case "ALERT_PERSON":
      return { ...state, alertPersons: action.data }
    case "SEARCH_USER_ANIMATION":
      return { ...state, userDataAnimation: action.data }
    case "SEARCH_USER_ANIMATION_DETAILS":
      return { ...state, userDataAnimationDetails: action.data }
    case "SEARCH_USER_AVIR_STATUS":
      return { ...state, avirStatus: action.data }
    case "SEARCH_USER_NTFACE_STATUS":
      return { ...state, ntfaceStatus: action.data }
    default:
      return state
  }
}

export default NTFS_STORE
